import { trans } from "@mongez/localization";
import { TabContentProps } from "../../types";
import { LeadershipCardBg } from "./LeadershipCardBg";

/**
 * Leadership Word content component
 * Displays chairman's message with image and content
 */
export function LeadershipWordContent({ data }: TabContentProps) {
  if (!data?.leadershipMessages) {
    return null;
  }

  return (
    <section className="container flex flex-col gap-6 pb-16 sm:gap-8 md:gap-10 lg:gap-8 xl:gap-10 3xl:gap-12">
      {data.leadershipMessages.map((message, index) => (
        <div
          key={index}
          className="relative rounded-2xl bg-white px-4 py-6 sm:rounded-3xl sm:px-6 sm:py-8 md:rounded-[44px] md:px-8 md:py-12 lg:px-10 lg:py-12 xl:px-12 xl:py-16 3xl:rounded-[52px] 3xl:px-16 3xl:py-20"
        >
          <div className="relative z-10 flex flex-col items-start gap-6 sm:gap-8 md:gap-10 lg:flex-row lg:items-end lg:gap-10 xl:gap-14 3xl:gap-16">
            <div className="order-2 w-full lg:order-1 lg:max-w-[1152px] 3xl:max-w-[1400px]">
              <div
                className="text-sm font-medium leading-relaxed tracking-[-0.03rem] opacity-[0.66] sm:text-base sm:leading-relaxed md:text-lg md:leading-7 lg:text-lg lg:leading-7 xl:text-xl xl:leading-8 2xl:text-2xl 3xl:text-3xl 3xl:leading-10"
                dangerouslySetInnerHTML={{ __html: trans(message.message) }}
              />

              <p className="mb-1 mt-4 text-lg font-semibold text-marine sm:mb-2 sm:mt-6 sm:text-xl md:mt-[30px] md:text-2xl lg:text-xl xl:text-2xl 2xl:mb-3 2xl:mt-8 3xl:mb-3 3xl:mt-10 3xl:text-3xl">
                {trans(message.name)}
              </p>

              <p className="text-base font-medium text-bright-orange sm:text-lg md:text-xl lg:text-lg xl:text-xl 2xl:text-2xl 3xl:text-2xl">
                {trans(message.title)}
              </p>
            </div>

            <div className="order-1 flex w-full justify-center lg:order-2 lg:w-auto lg:justify-end">
              <img
                src={message.image}
                alt={trans(message.name)}
                className="rounded-4 h-32 w-32 flex-shrink-0 object-cover sm:h-40 sm:w-40 md:h-48 md:w-48 lg:h-[180px] lg:w-[180px] xl:h-[200px] xl:w-[200px] 2xl:h-[243px] 2xl:w-[243px] 3xl:h-[280px] 3xl:w-[280px]"
              />
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 z-0 rtl:-scale-x-100">
            <LeadershipCardBg />
          </div>
        </div>
      ))}
    </section>
  );
}
